import React from "react";
import Modal from "../../../components/Modal";

type NewProjectModalProps = {
  isOpen: boolean;
  newProjectName: string;
  onClose: () => void;
  onNameChange: (name: string) => void;
  onSubmit: (e?: React.FormEvent) => void;
};

const NewProjectModal = ({
  isOpen,
  newProjectName,
  onClose,
  onNameChange,
  onSubmit,
}: NewProjectModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Buat Proyek Baru"
    size="sm"
    footer={
      <div className="flex justify-end gap-3 w-full">
        <button
          type="button"
          onClick={onClose}
          className="rounded-xl border border-solid border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 transition-all duration-200 hover:bg-slate-50"
        >
          Batal
        </button>
        <button
          type="button"
          onClick={() => onSubmit()}
          disabled={!newProjectName.trim()}
          className="rounded-xl border-none bg-blue-600 px-5 py-2.5 text-sm font-bold text-white transition-all duration-200 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
        >
          Buat Proyek
        </button>
      </div>
    }
  >
    <div className="p-2">
      <label className="block text-sm font-bold text-slate-700 mb-2">
        Nama Proyek
      </label>
      <input
        type="text"
        value={newProjectName}
        onChange={(e) => onNameChange(e.target.value)}
        placeholder="Masukkan nama proyek..."
        className="w-full rounded-xl border border-solid border-slate-300 bg-white px-4 py-3 text-sm font-medium text-slate-800 transition focus:border-blue-500 focus:outline-none focus:ring-4 focus:ring-blue-500/10"
        autoFocus
        onKeyDown={(e) => {
          if (e.key === "Enter") onSubmit();
        }}
      />
      <p className="mt-3 text-xs leading-relaxed text-slate-500">
        Proyek dari sini adalah proyek internal: tanpa klien di platform dan tanpa escrow Indoteknisi.
      </p>
    </div>
  </Modal>
);

export default NewProjectModal;
